import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { path, prop } from 'ramda';
import { asyncConnect } from 'react-async-client';
import Translate from 'react-translate-component';

import { fullAutoOptions } from 'constants/asyncClient';
import { getApprovalApplication, putApprovalApplication } from 'actions/asyncActions';
import { openModalApplicationCancel, openModalApplicationApprove } from 'actions/modalActions';
import { sidebarClose } from 'actions/sidebarActions';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import SidebarContainer from '../../SidebarContainer';
import { ApplicationCard } from '../application/ApplicationCard';
import ApprovalComments from '../../approvals/ApprovalComments';
import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';
import ActionDescriptionField from 'components/cards/education/action/ActionDescriptionField';

@asyncConnect({
    getApprovalApplication: getApprovalApplication
        .withPayload(({ id }) => id)
        .withOptions(fullAutoOptions),
    putApprovalApplication: putApprovalApplication
        .withSuccessHandler(({ sidebarClose }) => {
            sidebarClose();
        })
}, null, { openModalApplicationCancel, openModalApplicationApprove, sidebarClose })
export default class ApprovalApplicationSidebarView extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        getApprovalApplication: PropTypes.object.isRequired,
        openModalApplicationCancel: PropTypes.func.isRequired,
        openModalApplicationApprove: PropTypes.func.isRequired,
    };

    getFooter = (approval) => (
        <ApprovalButtons
            selected={approval}
            approve={() => this.props.openModalApplicationApprove([approval])}
            reject={() => this.props.openModalApplicationCancel([approval])}
        />
    )

    render() {
        const { params, getApprovalApplication: { data, meta, refresh } } = this.props;

        const application = prop('parent', data);
        const title = path(['vacancy', 'name'], data) || params.title;
        const footer = prop('inwork', data) && this.getFooter(data);
        const actionDescription = prop('actionDescription', data);

        return (
            <SidebarContainer meta={meta} refresh={refresh} title={title} footer={footer}>
                { meta.success && (
                    <Fragment>
                        <ApplicationCard item={application} />
                        <ActionDescriptionField descriptions={[actionDescription]} />
                        <DefinitionHeader iconType='check-circle'>
                            <Translate content='status' component='span'/>:
                            <span> {data.status}</span>
                        </DefinitionHeader>
                        <ApprovalComments comments={data.comments} />
                        { !!data.approvalComment && (
                            <div>
                                <DefinitionHeader translate='project.headers.comments' iconType='comment' />
                                <div className='panel-view'>
                                    <div className='text-pre-space'>
                                        <b>{data.approvalComment.employee.name}</b> &mdash; <span>{data.approvalComment.comment}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Fragment>
                )}
            </SidebarContainer>
        );
    }
}
